'use strict';

import React, { Fragment } from 'react';
import bemit from 'Functions/bemit';
import { formatNum } from '../../../FullStack/Shared/utilities';
import { service_units } from '../../../FullStack/Shared/options';
const configs = {
  'User': [{
    field: 'lastname',
    label: 'Nom'
  }, {
    field: 'firstname',
    label: 'Prénom'
  }],
  'CoworkingSpace': [{
    field: 'name',
    label: 'Nom'
  }],
  'Service': [{
    field: '_establishment.name',
    label: 'Établissement'
  }, {
    field: 'unit',
    label: 'Réservable à',
    hook: val => service_units.find(opt => opt.value === val)?.label || '-'
  }, {
    field: 'simple_price',
    label: 'Prix',
    hook: val => formatNum(val, '0,0[.]00') + ' € HT'
  }]
};
const models = {
  'User': 'Utilisateur (hôtelier)',
  'CoworkingSpace': 'Espaces',
  'Service': 'Service (à l\'établissement)'
};
export default function LinkedModelInfos(props) {
  let output = Object.keys(props.models || {}).filter(model => props.models[model].length > 0).map(function (model) {
    const config = configs[model];
    let output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-model-infos', [model.toLowerCase()]),
      key: model
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-model-infos__name"
    }, models[model]), props.models[model].map(document => getRow(config, document)));
    return output;
  });
  return output;
}
function getRow(config = [], document) {
  const cells = config.map(function (infos) {
    let value = infos.field.includes('.') ? document : document[infos.field];
    if (infos.field.includes('.')) {
      infos.field.split('.').forEach(function (sub_field) {
        value = value[sub_field];
      });
    }
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-model-infos__cell"
    }, typeof infos.hook === 'function' ? infos.hook(value) : value);
    return output;
  });
  const header = config.map(function (infos) {
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-model-infos__cell",
      key: infos.field
    }, infos.label);
    return output;
  });
  let output = /*#__PURE__*/React.createElement(Fragment, {
    key: document.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-model-infos__header"
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "c-model-infos__row"
  }, cells));
  return output;
}
